import * as React from 'react';
import Svg, { Path, SvgProps } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

export const WelcomeRipsIcon = (props: SvgProps) => (
    <Svg width={106} height={32} viewBox="0 0 106 32" fill="none" {...props}>
        <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0 31.4468V0.5532H15.1338C25.4213 0.5532 28.9922 5.617 28.9922 10.3404C28.9922 14.6809 25.5488 18.5532 20.1075 20.0426L30.395 31.4468H19.0447L10.0325 20.6383H9.3098V31.4468H0ZM14.6236 13.9575C17.2168 13.9575 19.1723 12.7234 19.1723 10.8511C19.1723 8.8511 17.3018 7.7021 14.6236 7.7021H9.3098V13.9575H14.6236Z"
            fill={ds.colorValue.icon.primary}
        />
        <Path d="M33.395 31.4468V0.5532H42.8536V31.4468H33.395Z" fill={ds.colorValue.icon.primary} />
        <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M45.8536 0.5532V31.4468H55.1844V22.5532H60.7659C70.821 22.5532 75.4651 17.4043 75.4651 11.4043C75.4651 5.7873 71.5879 0.5532 60.5102 0.5532H45.8536ZM65.4526 11.4894C65.4526 14.0426 63.0666 15.2766 59.8711 15.2766H55.1844V7.8298H59.8711C63.237 7.8298 65.4526 8.9787 65.4526 11.4894Z"
            fill={ds.colorValue.icon.primary}
        />
        <Path
            d="M91.6731 32C86.6881 32 81.4051 30.3404 78.9761 28L78.7631 18.4681C81.5751 21.9149 86.6881 24.383 91.3741 24.383C94.2721 24.383 96.1891 23.4894 96.1891 22.0426C96.1891 20.518 93.7851 19.9105 90.6771 19.1249C89.8811 18.9237 89.0391 18.7109 88.1791 18.4681C82.2141 16.8936 78.4651 14 78.4651 9.4043C78.4651 3.8298 84.4721 0 92.1841 0C96.9131 0 101.7701 1.4894 104.1991 3.0638L104.7951 12C101.0461 9.1064 96.4451 7.5319 92.2271 7.5319C89.5851 7.5319 87.7101 8.2553 87.7101 9.4894C87.7101 10.7949 89.4321 11.2406 92.7641 12.1028C93.5591 12.3086 94.4451 12.538 95.4221 12.8085C101.6431 14.3404 105.8181 16.9787 105.8181 21.9574C105.8181 27.8723 99.5121 32 91.6731 32Z"
            fill={ds.colorValue.icon.primary}
        />
    </Svg>
);
